import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        position: 'relative' as const
    },
    anchorText: {
        textDecorationLine: 'none' as const,
        color: theme?.app?.applicationColors.fontAnchorColor ||
            '#547dbf"'
    },
    backBar: {
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        flexBasis: 'auto' as const,
        paddingLeft: '1.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        fontSize: '1.2rem'
    },
    itemTitle: {
        height: '24px',
        width: '40px',
        paddingTop: '.75rem'
    },
    topContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        paddingLeft: '1.5rem',
        paddingTop: '2.8rem',
        paddingRight: '.5rem',
        paddingBottom: '1rem',
        flexBasis: 'auto' as const
    },
    killSwitchMessage: {
        fontSize: '1.1rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.lockColor ||
            '#F5824A'
    },
    tabContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '0',
        flexBasis: 'auto' as const,
        flexGrow: 1
    },
    backArrow: { width: '50px' },
    actionButtonContainer: {
        width: '100%',
        paddingTop: '0'
    },
    actionButton: { marginLeft: '15px' }
});